import React from "react";

const CollectionGrid = ({ categories }) => {
  return (
    <section className="w-full bg-white  my-[50px] 2xl:my-[100px]">
      <div className=" px-4 lg:px-[56px]">
        <h2 className="text-[24px] md:text-[30px] lg:text-[40px] 2xl:text-[60px] font-extrabold text-[#001D6E] text-center font-bricolage mb-12 max-w-[700px] mx-auto">
          Explore Our Biospecimen Collection
        </h2>

        {/* Desktop: Flex Container | Mobile: Grid */}
        <div className="flex flex-col lg:flex-row gap-4  mx-auto h-[100vh]">
          {categories.map((item, index) => (
            <div
              key={index}
              className="relative overflow-hidden  cursor-pointer transition-all duration-700 ease-in-out 
                         flex-[1] hover:flex-[2.5] group"
            >
              {/* Image with Dark Overlay */}
              <div className="absolute inset-0 bg-black/30 group-hover:bg-black/10 transition-colors duration-500 z-10" />
              <img
                src={item.image}
                alt={item.title}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />

              {/* Text Content */}
              <div className="absolute bottom-0 left-0 p-4 lg:p-8 z-20 w-full bg-gradient-to-t from-black/80 to-transparent">
                <h3 className="text-white text-[20px] 2xl:text-[30px] font-bold font-bricolage mb-2">
                  {item.title}
                </h3>

                {/* Description: Hidden by default, shown on hover */}
                <div className="max-h-0 opacity-0 group-hover:max-h-[200px] group-hover:opacity-100 transition-all duration-700 ease-in-out overflow-hidden">
                  <p className="text-white/90 text-sm lg:text-[24px] leading-relaxed mb-1 text-justify">
                    {item.description ||
                      "Fresh, frozen, or processed to your specifications with comprehensive clinical data."}
                  </p>
                  <p className="text-white/70 text-xs uppercase tracking-wider">
                    {item.subtext ||
                      "Plasma • Serum • Whole Blood • Urine • More"}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CollectionGrid;
